/* ViolationsRenderer.js */

"use strict";
const PopUpWidget = require("@gluenetworks/steve_ui_widgets").PopUp;
const _ = require("lodash");
const AuditPolicyResultTree = require("../../../../AuditPolicyResultTree");

class ViolationsRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("links-column");
        this._rootElem.component = this._model;
        this._popUpWidget = undefined;

        this._executionPlanLogIcon = document.createElement("actionable-icon-gl");
        this._executionPlanLogIcon.dataset.icon = "common.log_link";
        this._executionPlanLogIcon.setAttribute("title", "Violations (click to open)");

        this._logFile = document.createElement("log-display-gl");
        this._treeText = "";

        this._registerListeners();
        this.render();
    }

    /* ******************************************
    /* START PRIVATE COMPONENT RENDERER METHODS
    /* ****************************************** */
    _shutdown() {
        return new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._executionPlanLogIcon.remove();
            this._executionPlanLogIcon = undefined;
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            if (this._popUpWidget) {
                this._popUpWidget.removeAllListeners("PopUpVisible");
                this._popUpWidget = undefined;
            }
            this._logFile = undefined;
            this._treeText = undefined;
            resolve();
        });
    }

    _registerListeners() {
        this._model.on("Links", (this._onLinks = this._onLinks.bind(this)));
        this._executionPlanLogIcon.addEventListener(
            "click",
            (this._onIconClick = this._onIconClick.bind(this))
        );
    }

    _unregisterListeners() {
        this._model.removeAllListeners("Links");
        if (this._executionPlanLogIcon) {
            this._executionPlanLogIcon.removeEventListener("click", this._onIconClick);
        }
    }

    _setViolationsData() {
        if (this._rootElem === null) {
            return;
        }

        let viewexecutionPlanElement = document.createElement("view-more-pop-up");
        viewexecutionPlanElement.classList.add("results-log-popup", "violations-log-popup");
        viewexecutionPlanElement.innerHTML = this._getToolTipContent();
        this._popUpWidget = new PopUpWidget({
            content: viewexecutionPlanElement.outerHTML,
            anchor: this._executionPlanLogIcon,
            anchorPoint: "left",
            displayDirection: "bottomLeft",
            openOnHover: true,
            parent: viewexecutionPlanElement.parentNode,
        });
    }

    _getToolTipContent() {
        return `<span class="arrow"><i></i></span><div class="main-container p-b-0">${this._logFile.outerHTML}</div>`;
    }
    /* *****************************************
    /* END PRIVATE COMPONENT RENDERER METHODS
    /* START PUBLIC COMPONENT RENDERER METHODS
    /* ***************************************** */
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        this._setLinks(this._model.getLinks());
        this._onConfigAdded();
        return Promise.resolve();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /* *****************************************
    /* END COMPONENT RENDERER METHODS
    /* START HANDLER METHODS
    /* ***************************************** */

    _onLinks(newVal) {
        this._setLinks(newVal);
    }

    _onConfigAdded() {
        let violations = this._model.getViolations();
        this._setViolations(violations);
        this._setViolationsData();
    }

    _setViolations(logs) {
        const treeHtmlString = new AuditPolicyResultTree(logs).getTreeHtml();
        this._treeText = treeHtmlString;
        const preEl = document.createElement("pre");
        preEl.innerText = treeHtmlString;
        this._logFile.innerHTML = preEl.outerHTML;
    }

    _onIconClick(event) {
        // Keep the click off the row, which would select it or open the detail editor.
        event.stopPropagation();
        this._model.openFullText(this._treeText);
    }

    /* *****************************************
    /* END HANDLER METHODS
    /* START PRIVATE API METHODS
    /* ***************************************** */

    _setLinks(newVal) {
        if (!_.isEmpty(newVal.evalResults)) {
            this._rootElem.innerHTML = "";
            this._rootElem.appendChild(this._executionPlanLogIcon);
        }
    }

    /* *****************************************
    /* END PRIVATE API METHODS
    /* ***************************************** */
}

module.exports = ViolationsRenderer;
